import React from "react";
import { NavLink } from "react-router-dom";
import { Home, ListChecks, PieChart, User } from "lucide-react";

const items = [
  { to: "/", icon: Home, label: "Início", testid: "nav-dashboard" },
  { to: "/movimentacoes", icon: ListChecks, label: "Extrato", testid: "nav-transactions" },
  { to: "/relatorios", icon: PieChart, label: "Relatórios", testid: "nav-reports" },
  { to: "/perfil", icon: User, label: "Perfil", testid: "nav-profile" },
];

export default function BottomNav() {
  return (
    <nav className="fixed bottom-0 inset-x-0 z-40 sm:sticky sm:bottom-4 sm:mt-8 pointer-events-none">
      <div className="max-w-md mx-auto px-4 pb-3 pt-2 sm:pb-0 pointer-events-auto">
        <div
          className="rounded-3xl px-2 py-2 flex items-center justify-around border border-white/10"
          style={{
            background: "linear-gradient(180deg, rgba(23, 43, 82, 0.85), rgba(10, 23, 48, 0.92))",
            backdropFilter: "blur(20px) saturate(160%)",
            WebkitBackdropFilter: "blur(20px) saturate(160%)",
            boxShadow: "0 20px 40px -12px rgba(0,0,0,0.5), 0 1px 0 rgba(255,255,255,0.05) inset",
          }}
        >
          {items.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.to === "/"}
              data-testid={it.testid}
              className={({ isActive }) =>
                `relative flex flex-col items-center gap-0.5 px-3 py-1.5 rounded-2xl min-w-[64px] ${
                  isActive
                    ? "text-emerald-300 bg-emerald-500/12"
                    : "text-slate-400 hover:text-white"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  {isActive && (
                    <span className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 rounded-full bg-emerald-400" />
                  )}
                  <it.icon className="w-5 h-5" strokeWidth={2.2} />
                  <span className="text-[10px] font-semibold tracking-wide">{it.label}</span>
                </>
              )}
            </NavLink>
          ))}
        </div>
      </div>
    </nav>
  );
}
